import { gql } from '@apollo/client';

export const GET_ALL_BOOKMARKS = gql`
  query GetAllBookmarks($id: ID!) {
    book(id: $id) {
      id
      title
      bookmarks {
        page
        text
        ts
      }
    }
  }
`;

export const ADD_BOOKMARK = gql`
  mutation AddBookmark($bookId: Int!, $page: Int!, $text: String) {
    addBookmark(bookId: $bookId, page: $page, text: $text) {
      page
      text
      ts
    }
  }
`;

export const REMOVE_BOOKMARK = gql`
  mutation RemoveBookmark($bookId: Int!, $page: Int!) {
    removeBookmark(bookId: $bookId, page: $page) {
      page
      text
      ts
    }
  }
`;
